export const ProjectSource =[
    {
        title:'github',
        url:'https://github.com/badu01'
    },
    {
        title:'figma',
        url:'https://figma.com/@badushapareed'
    },
    {
        title:'dribbble',
        url:'https://dribbble.com/badu01'
    }
]